export function initializeEntityDisplayState(entityIds) {
    return {
        entityIds: [...entityIds],
        activeEntityId: entityIds.length > 0 ? entityIds[0] : null,
        activeEntityEditorScrollSignal: 0,
        activeEntityMenuScrollSignal: 0,
    };
}
export function reduceEntityDisplayState(state, action) {
    const newState = action.reduce(state);
    // if (state !== newState) console.log(`State changed for ${action.constructor.name}`, state, action, newState);
    return newState;
}
// ACTIONS
class AddEntityAction {
    entityId;
    constructor(entityId) {
        this.entityId = entityId;
    }
    reduce(state) {
        let { activeEntityEditorScrollSignal, activeEntityMenuScrollSignal } = state;
        if (state.entityIds.some((it) => it === this.entityId)) {
            activeEntityEditorScrollSignal++;
            activeEntityMenuScrollSignal++;
            return {
                ...state,
                activeEntityId: this.entityId,
                activeEntityEditorScrollSignal,
                activeEntityMenuScrollSignal,
            };
        }
        return { ...state, entityIds: [...state.entityIds, this.entityId] };
    }
}
class RemoveEntityAction {
    entityId;
    constructor(entityId) {
        this.entityId = entityId;
    }
    reduce(state) {
        let { activeEntityId } = state;
        if (activeEntityId === this.entityId) {
            activeEntityId = null;
        }
        return {
            ...state,
            activeEntityId,
            entityIds: state.entityIds.filter((id) => id !== this.entityId),
        };
    }
}
class SetActiveEntityAction {
    id;
    increaseMenuScrollSignal;
    increaseEditorScrollSignal;
    constructor(id, increaseMenuScrollSignal, increaseEditorScrollSignal) {
        this.id = id;
        this.increaseMenuScrollSignal = increaseMenuScrollSignal;
        this.increaseEditorScrollSignal = increaseEditorScrollSignal;
    }
    reduce(state) {
        if (state.activeEntityId === this.id) {
            return state;
        }
        if (!state.entityIds.some((id) => id === this.id)) {
            throw new Error(`No entity with id '${this.id}`);
        }
        let { activeEntityMenuScrollSignal, activeEntityEditorScrollSignal } = state;
        if (this.increaseMenuScrollSignal) {
            activeEntityMenuScrollSignal += 1;
        }
        if (this.increaseEditorScrollSignal) {
            activeEntityEditorScrollSignal += 1;
        }
        return {
            ...state,
            activeEntityId: this.id,
            activeEntityMenuScrollSignal,
            activeEntityEditorScrollSignal,
        };
    }
}
export const EntityDisplayActions = {
    AddEntity: AddEntityAction,
    RemoveEntity: RemoveEntityAction,
    SetActiveEntity: SetActiveEntityAction,
};
//# sourceMappingURL=EntityDisplayReducer.js.map